import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DialogsService} from "../../../services/manage/dialogs/dialogs.service";
import {ProductService} from "../../../services/api/product/product.service";
import {CssService} from "../../../services/css-service";
import {FulleStockService} from "../../../services/api/fulle/fulle-stock/fulle-stock.service";

@Component({
  selector: 'app-product-item-list',
  templateUrl: './product-item-list.component.html',
  styleUrls: ['./product-item-list.component.css']
})
export class ProductItemListComponent implements OnInit {

  @Output() openProdDialEvent = new EventEmitter<any>();
  @Input() prod : any = null;
  @Input()
  merchantClient$: any;
  @Input()
  displayMode: any = 0;
  stock : any = null
  default_prod: string = "/assets/img/not-found.png";

  constructor(
    public myDials : DialogsService,
    public cssService : CssService,
    public stockService : FulleStockService,
    public productService : ProductService
  ) { }

  ngOnInit(): void {
    this.refreshStock();
  }

  refreshStock(){
    this.stock = this.stockService.stocks[this.prod.id]
  }

  isOutOfStock(){
    return this.stock && this.stock.count <= 0;
  }

  openProdDial(prod: any, data?: any): void {
    this.openProdDialEvent.emit(prod);
  }
}
